import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

export const getAllPaintSchemes = async (page, size, searchString) => {
    const response = await api.get(`/${ENDPOINTS.PAINT_SCHEME_TABLE}`, {
        params: { page, size, search: searchString },
    });
    return response.data;
};

export const updatePaintScheme = async (id, body) => {
    const response = await api.put(`/${ENDPOINTS.PAINT_SCHEME_TABLE}/${id}`, body);
    return response.data;
};

export const getPaintSchemeSourcePdf = async () => {
    const response = await api.get(`/${ENDPOINTS.PAINT_SCHEME_TABLE}/source`, {
        responseType: "blob",
    });
    return response.data;
};